// PR-28: project list cache so the picker works offline. Single key
// 'all' — there's no per-user partitioning (the auth layer already gates
// who can see what; on the client side a single user owns the device).

import type { Project } from '../api'
import { getValue, putValue } from './indexed_db'

const STORE = 'projects_list'
const CACHE_KEY = 'all'

interface ProjectsCacheEntry {
  cache_key: string
  projects: Project[]
  cached_at: number
}

export async function read(): Promise<Project[] | undefined> {
  const entry = await getValue<ProjectsCacheEntry>(STORE, CACHE_KEY)
  return entry?.projects
}

export async function write(projects: Project[]): Promise<void> {
  const entry: ProjectsCacheEntry = {
    cache_key: CACHE_KEY,
    projects,
    cached_at: Date.now(),
  }
  await putValue(STORE, entry)
}
